import { render, staticRenderFns } from "./WageAverageInput.vue?vue&type=template&id=4ade5435&"
import script from "./WageAverageInput.vue?vue&type=script&lang=js&"
export * from "./WageAverageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports